// material-ui
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// project imports
import Dot from 'components/@extended/Dot';
import { useAdminMode } from 'contexts/AdminModeContext';

const OPTIONS = {
  live: { label: 'Produção', color: 'success' },
  test: { label: 'Sandbox', color: 'warning' }
};

// ==============================|| ADMIN HEADER - SELETOR PRODUÇÃO / SANDBOX ||============================== //

export default function AdminModeSelector() {
  const { mode, setMode } = useAdminMode();

  return (
    <FormControl size="small">
      <Select
        id="admin-mode-select"
        value={mode}
        onChange={(event) => setMode(event.target.value)}
        inputProps={{ 'aria-label': 'Modo de dados: Produção ou Sandbox' }}
        renderValue={(value) => (
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
            <Dot color={OPTIONS[value].color} size={8} />
            <Typography variant="subtitle2">{OPTIONS[value].label}</Typography>
          </Stack>
        )}
        sx={(theme) => ({
          minWidth: { xs: 120, sm: 140 },
          ...(mode === 'test' && {
            bgcolor: 'warning.lighter',
            '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.warning.main }
          })
        })}
      >
        {Object.entries(OPTIONS).map(([value, option]) => (
          <MenuItem key={value} value={value}>
            <Stack direction="row" spacing={1.25} sx={{ alignItems: 'center' }}>
              <Dot color={option.color} size={8} />
              <Typography variant="subtitle2">{option.label}</Typography>
            </Stack>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
